export default __webpack_public_path__ + "static/media/screen5.3d1fe7ac.png";